<template>
  <div :class="classes" v-loading="loading&&defaultLoading">
    <pt-page-title title="编辑基因检测套餐"></pt-page-title>
    <template v-if="detectionPackage">
       <detection-package-form v-model="detectionPackage" ref="child" :default-base-package="defaultBasePackage"></detection-package-form>
    </template>
    <div class="marginTop">
      <el-button type="primary" @click="editDetectionPackage">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import detectionPackageForm from 'cps/gene-product/detection-package-form'
const prefixCls = 'pt-detection-package-update'

export default {
  name: 'pt-detection-package-update',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    detectionPackageForm
  },
  data () {
    return {
      // 用于绑定的产品数据对象
      id: this.$route.params.id,
      detectionPackage: this.$route.params.value ? this.isNull(this.$route.params.value) : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      detectionItemCache: [],
      updateLoading: false,
      defaultBasePackage: null,
      defaultLoading: false
    }
  },
  methods: {
    isNull (obj) {
      if (obj.reportParameters == null) {
        obj.reportParameters = {}
      }
      if (obj.reportStyles == null) {
        obj.reportStyles = {}
      }
      return obj
    },
    // 加载详情数据
    load () {
      this.loading = true
      this.defaultLoading = true
      this.loadFailed = false

      this.$store.dispatch('getDetectionPackage', this.id).then((response) => {
        this.loadFailed = false
        this.loading = false
        this.detectionPackage = this.isNull(response.data)
        this.detectionItemCache = response.data.detectionItemCache
        if (this.detectionPackage.defaultBasePackageId) {
          this.getPackageList()
        }
        // console.log('pa---------', this.detectionPackage)
        this.changFormat(this.detectionPackage)
        if (this.detectionPackage.packageType !== 'DEFAULT_WHOLE_GENOM') {
          this.detectionPackage.packageType = 'OTHER'
        }
      }).catch((error) => {
        console.log(error)
        this.loading = false
        this.loadFailed = true
        this.$message.error('获取信息失败！')
      })
    },
    changData (fullObj) {
      if (fullObj.items) {
        fullObj.items.forEach((element, index) => {
          if (element.type === 'DETECTION') {
            if (element.id) {
              element.detectionItemId = element.id
            }
          } else {
            this.changData(element)
          }
        })
      }
    },
    editDetectionPackage () {
      this.$refs.child.formValidate().then(() => {
        this.loading = true
        // console.log('参数----------', this.detectionPackage)
        if (this.detectionPackage.reportParameters.splitBooks === false) {
          this.detectionPackage.reportParameters.bookSplittingParameters = {
            'book0StartChapter': '',
            'book1StartChapter': ''
          }
        }
        // 编辑时非基础套餐的只能传“CUSTOMER”
        let copyData = JSON.parse(JSON.stringify(this.detectionPackage))
        if (copyData.packageType === 'OTHER') {
          copyData.packageType = 'CUSTOMER'
        }
        this.$delete(copyData, 'detectionItemConfigCache')
        this.$delete(copyData, 'detectionItemCache')
        this.changData(copyData)
        this.$store.dispatch('updateDetectionPackage', copyData).then((response) => {
          this.$message.success('修改成功!')
          this.loading = false
          history.go(-1)
        }).catch((error) => {
          console.error(error)
          this.loading = false
          this.$message.error(error)
        })
      })
    },
    cancel () {
      history.go(-1)
    },
    changFormat (fullObj) {
      if (fullObj.items) {
        fullObj.items.forEach(element => {
          if (element.type === 'DETECTION') {
            element.name = this.getDetection(element.detectionItemId)
          } else {
            this.changFormat(element)
          }
        })
      }
    },
    getPackageList () {
      let data = {
        pageable: {
          page: 0,
          size: 99999
        },
        example: {
          packageType: 'DEFAULT_WHOLE_GENOM'
        }
      }
      this.defaultLoading = true
      this.$store.dispatch('getPackageList', data).then(res => {
        this.defaultLoading = false
        res.data.forEach(item => {
          if (item.id === this.detectionPackage.defaultBasePackageId) {
            this.defaultBasePackage = item
          }
        })
        // 如果基础套餐被删除了，修改一级分类套餐或者以这个基础套餐为基础的其他套餐时，需要重置defaultBasePackageId和basePackageName
        if (!this.defaultBasePackage) {
          this.detectionPackage.defaultBasePackageId = ''
          this.detectionPackage.basePackageName = ''
        }
      }).catch(err => {
        this.defaultLoading = false
        this.$message.error(err || '获取基础套餐列表失败')
      })
    },
    getDetection (detectionItemId) {
      for (var i = 0; i < this.detectionItemCache.length; i++) {
        if (this.detectionItemCache[i].id === detectionItemId) {
          return this.detectionItemCache[i].chineseName
        }
      }
    }
  },
  created () {
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    this.id = this.$route.params.id
    if (!this.detectionPackage) {
      this.load()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
